import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import WhatsAppBubble from "@/components/site/WhatsAppBubble";
import CatalogSection from "@/components/site/CatalogSection";

// Dedicated /catalog page — loads at the top of the viewport (padded below the
// fixed navbar) and reuses the same CatalogSection component that lives on the
// homepage. Prevents the "jumps to bottom" behaviour caused by the previous
// /#catalog anchor navigation. CatalogSection itself renders the page's <Seo>,
// <h1> and breadcrumbs when `standalone` is set.
export default function CatalogPage() {
  return (
    <div className="relative min-h-screen" data-testid="catalog-page">
      <Navbar />
      <main className="relative pt-24 md:pt-28">
        <CatalogSection standalone />
      </main>
      <Footer />
      <WhatsAppBubble />
    </div>
  );
}
